/* eslint-disable no-unexpected-multiline */
/* eslint-disable no-unused-vars */

import {
  app,
} from './initializeApp';

import {
  ensureUser,
} from './ensureUser';

import {
  getAuth,
} from 'firebase/auth';

const auth = getAuth(app);

export async function getUid()
{
  await ensureUser();

  return auth
  .currentUser
  .uid;
}